import { BsCalendar2Week, BsThreeDotsVertical } from "react-icons/bs";
import { ButtonComp, DropDownComp, ToolTips } from "../../components";
import {
  formatMoney,
  NAIRA_SIGN,
  getTransactionSignedAmountForDisplay,
} from "../currencyFormat";
import FallbackImage from "../../components/Common/ImageWrapper.jsx";
import moment from "moment";
import { convertToTitleCase } from "../helpers";
import { getStatusBadgeColor } from "../communicationUtils";
import CustomRadioComp from "../../components/Ui/CustomRadioComp";
import MemberLoanRepaymentGuarantorsCell from "../../pages/Members/LoanManagement/MemberLoanRepaymentGuarantorsCell";

const colors = [
  "var(--color-secondary-soft)",
  "#A8E1C8",
  "var(--color-primary-soft)",
];

export const ViewStaffData = [
  {
    id: "1",
    staffName: "Kolawole Tolu",
    phone: "0813356693",
    name: "Form fee",
    branch: "Asddls ssjjs sjsj",
    status: "Active",
    status1: "Compulsory",
    amount: 400000,
    date: "12-05-2022",
    days: "15days",
    address: "34, Jinadu street, Agege, Lagos",
    email: "oreofecs@uniquecoop.com",
    prefixNumber: "ORF-2022",
    prefixCount: "001",
    role: "Secretary",
    accountNumber: "0814037009",
    accountName: "Ifesowapo C & S",
    desc: "General annual meeting",
    duration: "3 hours",
    venue: "Cooperative secretariat",
  },
  {
    id: "1",
    staffName: "KKOO Tolu",
    phone: "08123784567",
    name: "Form fee",
    branch: "Asddls ssjjs sjsj",
    status: "Active",
    status1: "Compulsory",
    amount: 100000,
    date: "12-05-2022",
    days: "15days",
    address: "34, Jinadu street, Agege, Lagos",
    email: "oreofecs@uniquecoop.com",
    prefixNumber: "ORF-2022",
    prefixCount: "001",
    role: "Secretary",
    accountNumber: "0814037009",
    accountName: "Ifesowapo C & S",
    desc: "General annual meeting",
    duration: "3 hours",
    venue: "Cooperative secretariat",
  },
];

export const ViewStaffHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row, index) => (
        <span className="fw-bold text-black">{index + 1}</span>
      ),
      width: "60px",
    },
    {
      name: "Staff name",
      grow: 2,
      selector: (row) => (
        <span className=" flex items-center">
          <span className="me-3">
            <img
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
              src={row?.photo}
              alt="profile_img"
            />
          </span>
          {`${row?.first_name}  ${row?.last_name}`}
        </span>
      ),
    },
    {
      name: "Phone number",
      selector: (row) => row?.phone,
      width: "140px",
    },
    {
      name: "Role",
      grow: 1,
      minWidth: "140px",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {row?.role?.name || "—"}
        </span>
      ),
    },
    {
      name: "Branch(es)",
      grow: 2,
      selector: (row) => {
        // Get unique branches (excluding the active branch)
        const activeBranchId = row?.active_branch?.id;
        // Filter out null branches and exclude the active branch
        const otherBranches =
          row?.branches?.filter(
            (branchItem) => branchItem?.branch && branchItem.branch?.id !== activeBranchId
          ) || [];

        return (
          <div className="d-flex">
            {row?.active_branch?.name && (
              <div
                style={{ background: "var(--color-secondary-soft)", color: "var(--color-secondary)" }}
                className="px-2 py-1 rounded-pill me-2"
              >
                {row?.active_branch?.name}
              </div>
            )}
            {otherBranches.length > 0 && (
              <div
                style={{ background: "var(--color-primary-soft)", color: "var(--color-primary)" }}
                className="px-2 py-1 rounded-pill"
              >
                {otherBranches.length} other(s)
              </div>
            )}
            {!row?.active_branch?.name && otherBranches.length === 0 && (
              <span className="text-muted">No branch assigned</span>
            )}
          </div>
        );
      },
    },
    {
      name: "Last login",
      minWidth: "160px",
      selector: (row) => {
        if (!row?.last_login_at) {
          return <span className="text-muted" style={{ fontSize: "14px" }}>Never</span>;
        }
        const formatted = moment(row.last_login_at);
        if (!formatted.isValid()) {
          return <span className="text-muted" style={{ fontSize: "14px" }}>—</span>;
        }
        return (
          <span className="fw-2 text-black1" style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
            {formatted.format("DD-MMM-YYYY HH:mm")}
          </span>
        );
      },
    },
    {
      name: "Staff status",
      width: "120px",
      selector: (row) => (
        <div
          style={{
            background: `${row.is_suspended === 0 ? "#19BC31" : "#FF4343"}`,
          }}
          className="px-2 py-1 rounded-pill text-white"
        >
          {row.is_suspended === 0 ? "Active" : "Suspended"}
        </div>
      ),
    },
    {
      name: "Action",
      width: "80px",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown(row)}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
    },
  ];
};

export const StaffTransactionHistoryHeader = (TableDropDown) => {
  // Get transaction type display name
  const getTransactionTypeName = (transaction) => {
    return transaction?.display_type || convertToTitleCase(transaction?.type) || "Transaction";
  };

  // Get status badge color
  const getStatusColor = (status) => {
    const statusUpper = (status || "").toUpperCase();
    if (statusUpper === "SUCCESSFUL" || statusUpper === "PROCESSED" || statusUpper === "PAID") {
      return "#19BC31"; // Green
    }
    if (statusUpper === "PENDING") {
      return "#FFA500"; // Orange
    }
    if (statusUpper === "FAILED" || statusUpper === "DECLINED") {
      return "#FF4343"; // Red
    }
    return "#A1A0A0"; // Grey
  };

  // Get payment method display name
  const getPaymentMethodName = (transaction) => {
    return transaction?.display_payment_method || transaction?.payment_method || "N/A";
  };

  return [
    {
      name: "S/N",
      selector: (row, index) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {index + 1}
        </span>
      ),
      width: "70px",
    },
    {
      name: "Member",
      selector: (row) => {
        let memberName = "N/A";
        if (typeof row?.member === 'string') {
          memberName = row.member;
        } else if (row?.member && typeof row.member === 'object') {
          if (row.member.first_name) {
            memberName = `${row.member.first_name} ${row.member.last_name || ""}`.trim();
          } else if (row.member.name) {
            memberName = String(row.member.name);
          } else {
            memberName = "N/A";
          }
        }
        
        const memberNo = String(row?.member_no || row?.member?.member_no || "");
        
        return (
          <div>
            <div className="fw-bold text-black1" style={{ fontSize: "14px" }}>
              {String(memberName)}
            </div>
            <small className="text-muted" style={{ fontSize: "12px" }}>
              {memberNo ? `Membership No: ${memberNo}` : ""}
            </small>
          </div>
        );
      },
      minWidth: "180px",
    },
    {
      name: "Transaction Type",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {getTransactionTypeName(row)}
        </span>
      ),
      minWidth: "200px",
    },
    {
      name: "Reference",
      selector: (row) => (
        <span className="text-muted" style={{ fontSize: "13px", fontFamily: "monospace" }}>
          {row?.reference || "N/A"}
        </span>
      ),
      minWidth: "150px",
    },
    {
      name: "Amount",
      selector: (row) => {
        const safe = getTransactionSignedAmountForDisplay(row);
        const isCredit = safe > 0;
        const isDebit = safe < 0;
        const typeUpper = (row?.type || "").toString().toUpperCase();
        const showFlowBadge =
          typeUpper === "OPENING_BALANCE_CORRECTION" ||
          typeUpper === "OPENING_BALANCE_IMPORT" ||
          typeUpper === "CONTRIBUTION" ||
          typeUpper === "LOAN";
        return (
          <div className="d-flex flex-column gap-1 align-items-start">
            <span
              className="fw-bold"
              style={{
                fontSize: "14px",
                color: isDebit ? "#d40000" : isCredit ? "#19BC31" : "#45464E",
              }}
            >
              {formatMoney(safe.toFixed(2), true, NAIRA_SIGN)}
            </span>
            {showFlowBadge && (isCredit || isDebit) ? (
              <span
                className="rounded-pill text-white px-2 py-0"
                style={{
                  fontSize: "10px",
                  backgroundColor: isDebit ? "#d40000" : "#19BC31",
                }}
              >
                {isDebit ? "Debit" : "Credit"}
              </span>
            ) : null}
          </div>
        );
      },
      minWidth: "150px",
    },
    {
      name: "Payment Method",
      selector: (row) => (
        <span className="text-muted" style={{ fontSize: "13px" }}>
          {getPaymentMethodName(row)}
        </span>
      ),
      minWidth: "130px",
    },
    {
      name: "Date & Time",
      selector: (row) => {
        const date = row?.created_at || row?.date;
        if (!date) return <span className="text-muted">N/A</span>;
        
        return (
          <div>
            <div style={{ fontSize: "13px", fontWeight: 500 }}>
              {moment(date).format("DD-MMM-YYYY")}
            </div>
            <div className="text-muted" style={{ fontSize: "12px" }}>
              {moment(date).format("hh:mm A")}
            </div>
          </div>
        );
      },
      minWidth: "140px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = row?.status || "PENDING";
        const statusColor = getStatusColor(status);
        
        return (
          <div
            className="px-3 py-1 rounded-pill text-white text-center"
            style={{
              backgroundColor: statusColor,
              fontSize: "12px",
              minWidth: "100px",
            }}
          >
            {convertToTitleCase(status)}
          </div>
        );
      },
      width: "120px",
    },
    {
      name: "Actions",
      cell: (row) => {
        if (!TableDropDown || TableDropDown.length === 0) {
          return <span className="text-muted">-</span>;
        }
        
        return (
          <div className="text-center">
            <DropDownComp
              dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
              arrayComp={TableDropDown}
              ItemClassName="pe-5 text-2"
              input="name"
              row={row}
              DropDownText={
                <span>
                  <BsThreeDotsVertical size={20} className="table-action-icon" />
                </span>
              }
            />
          </div>
        );
      },
      width: "100px",
    },
  ];
};

export const MemberTransactionHistoryData = [
  {
    id: "1",
    con: "Kolawole Tolu",
    amount: 4000,
    branch: "Asddls ssjjs sjsj",
    status: "Successful",
    date: "12-04-2022",
    time: "12:30 PM",
  },
];
export const MemberTransactionHistoryHeader = (TableDropDown) => {
  // Get transaction type display name
  const getTransactionTypeName = (transaction) => {
    return transaction?.display_type || convertToTitleCase(transaction?.type) || "Transaction";
  };

  // Get status badge color
  const getStatusColor = (status) => {
    const statusUpper = (status || "").toUpperCase();
    if (statusUpper === "SUCCESSFUL" || statusUpper === "PROCESSED" || statusUpper === "PAID") {
      return "#19BC31"; // Green
    }
    if (statusUpper === "PENDING") {
      return "#FFA500"; // Orange
    }
    if (statusUpper === "FAILED" || statusUpper === "DECLINED") {
      return "#FF4343"; // Red
    }
    return "#A1A0A0"; // Grey
  };

  // Get payment method display name
  const getPaymentMethodName = (transaction) => {
    return transaction?.display_payment_method || transaction?.payment_method || "N/A";
  };

  return [
    {
      name: "S/N",
      selector: (row, index) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {index + 1}
        </span>
      ),
      width: "70px",
    },
    {
      name: "Transaction Type",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {getTransactionTypeName(row)}
        </span>
      ),
      minWidth: "200px",
    },
    {
      name: "Reference",
      selector: (row) => (
        <span className="text-muted" style={{ fontSize: "13px", fontFamily: "monospace" }}>
          {row?.reference || "N/A"}
        </span>
      ),
      minWidth: "150px",
    },
    {
      name: "Amount",
      selector: (row) => {
        const safe = getTransactionSignedAmountForDisplay(row);
        const isCredit = safe > 0;
        const isDebit = safe < 0;
        const typeUpper = (row?.type || "").toString().toUpperCase();
        const showFlowBadge =
          typeUpper === "OPENING_BALANCE_CORRECTION" ||
          typeUpper === "OPENING_BALANCE_IMPORT" ||
          typeUpper === "CONTRIBUTION" ||
          typeUpper === "LOAN";
        return (
          <div className="d-flex flex-column gap-1 align-items-start">
            <span
              className="fw-bold"
              style={{
                fontSize: "14px",
                color: isDebit ? "#d40000" : isCredit ? "#19BC31" : "#45464E",
              }}
            >
              {formatMoney(safe.toFixed(2), true, NAIRA_SIGN)}
            </span>
            {showFlowBadge && (isCredit || isDebit) ? (
              <span
                className="rounded-pill text-white px-2 py-0"
                style={{
                  fontSize: "10px",
                  backgroundColor: isDebit ? "#d40000" : "#19BC31",
                }}
              >
                {isDebit ? "Debit" : "Credit"}
              </span>
            ) : null}
          </div>
        );
      },
      minWidth: "150px",
    },
    {
      name: "Payment Method",
      selector: (row) => (
        <span className="text-muted" style={{ fontSize: "13px" }}>
          {getPaymentMethodName(row)}
        </span>
      ),
      minWidth: "130px",
    },
    {
      name: "Date & Time",
      selector: (row) => {
        const date = row?.created_at || row?.date;
        if (!date) return <span className="text-muted">N/A</span>;
        
        return (
          <div>
            <div style={{ fontSize: "13px", fontWeight: 500 }}>
              {moment(date).format("DD-MMM-YYYY")}
            </div>
            <div className="text-muted" style={{ fontSize: "12px" }}>
              {moment(date).format("hh:mm A")}
            </div>
          </div>
        );
      },
      minWidth: "140px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = row?.status || "PENDING";
        const statusColor = getStatusColor(status);
        
        return (
          <div
            className="px-3 py-1 rounded-pill text-white text-center"
            style={{
              backgroundColor: statusColor,
              fontSize: "12px",
              minWidth: "100px",
            }}
          >
            {convertToTitleCase(status)}
          </div>
        );
      },
      width: "120px",
    },
    {
      name: "Actions",
      cell: (row) => {
        if (!TableDropDown || TableDropDown.length === 0) {
          return <span className="text-muted">-</span>;
        }
        
        return (
          <div className="text-center">
            <DropDownComp
              dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
              arrayComp={TableDropDown}
              ItemClassName="pe-5 text-2"
              input="name"
              row={row}
              DropDownText={
                <span>
                  <BsThreeDotsVertical size={20} className="table-action-icon" />
                </span>
              }
            />
          </div>
        );
      },
      width: "100px",
    },
  ];
};

export const pendingMemberHeader = (
  setModalToggle,
  setModalPage,
  setMemberId,
  onViewDetails
) => {
  return [
    {
      name: "S/N",
      selector: (row) => (
        <span className="fw-bold" style={{ color: "#45464e" }}>
          {row.serialNumber}
        </span>
      ),
      width: "70px",
    },
    {
      name: "Member name",
      selector: (row) => (
        <div className="d-flex align-items-center">
          <FallbackImage
            src={row?.photo || "/Staff/avatar.svg"}
            width="32px"
            height="32px"
            className="rounded-circle me-3"
            style={{ objectFit: "cover" }}
          />
          <span
            className="fw-semibold"
            style={{
              color: "#45464e",
              cursor: onViewDetails ? "pointer" : "default",
            }}
            onClick={() => {
              if (onViewDetails) {
                onViewDetails(row.id);
              }
            }}
            onMouseEnter={(e) => {
              if (onViewDetails) {
                e.target.style.color = "var(--color-secondary)";
                e.target.style.textDecoration = "underline";
              }
            }}
            onMouseLeave={(e) => {
              if (onViewDetails) {
                e.target.style.color = "#45464e";
                e.target.style.textDecoration = "none";
              }
            }}
          >
            {row?.name}
          </span>
        </div>
      ),
      minWidth: "200px",
    },
    {
      name: "Phone number",
      selector: (row) => (
        <span style={{ color: "#525252", fontSize: "14px" }}>
          {row?.phone || "-"}
        </span>
      ),
      minWidth: "140px",
    },
    {
      name: "Email",
      selector: (row) => (
        <span style={{ color: "#525252", fontSize: "14px" }}>
          {row?.email || "-"}
        </span>
      ),
      minWidth: "180px",
    },
    {
      name: "Branch",
      selector: (row) => (
        <span
          className="px-3 py-1 rounded-pill fw-semibold"
          style={{
            backgroundColor: "var(--color-secondary-soft)",
            color: "var(--color-secondary)",
            fontSize: "13px",
            whiteSpace: "nowrap",
            display: "inline-block",
          }}
        >
          {row?.branch || "-"}
        </span>
      ),
      minWidth: "150px",
    },
    {
      name: "ACTION",
      cell: (row) => (
        <div className="d-flex gap-2 flex-wrap" style={{ minWidth: "280px" }}>
          {onViewDetails && (
            <ButtonComp
              onClick={() => {
                onViewDetails(row.id);
              }}
              btnText={"View Details"}
              btnClassName="px-3 py-2 fw-semibold rounded"
              style={{
                backgroundColor: "var(--color-secondary)",
                border: "none",
                color: "#ffffff",
                fontSize: "14px",
                whiteSpace: "nowrap",
                minWidth: "fit-content",
              }}
            />
          )}
          <ButtonComp
            onClick={() => {
              setMemberId(row.id);
              setModalPage(0);
              setModalToggle(true);
            }}
            btnText={"Approve"}
            btnClassName="px-3 py-2 fw-semibold text-white rounded"
            style={{
              backgroundColor: "var(--color-primary)",
              border: "none",
              fontSize: "14px",
              whiteSpace: "nowrap",
              minWidth: "fit-content",
              flex: onViewDetails ? 1 : "none",
            }}
          />
          <ButtonComp
            onClick={() => {
              setMemberId(row.id);
              setModalPage(1);
              setModalToggle(true);
            }}
            btnText={"Decline"}
            btnClassName="px-3 py-2 fw-semibold rounded"
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e0e0e0",
              color: "#45464e",
              fontSize: "14px",
              whiteSpace: "nowrap",
              minWidth: "fit-content",
              flex: onViewDetails ? 1 : "none",
            }}
          />
        </div>
      ),
      minWidth: "280px",
    },
  ];
};

export const ContributionHistoryHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row, index) => <span className="text-muted">{index + 1}</span>,
      width: "70px",
    },
    {
      name: "Contribution name",
      selector: (row) => (
        <div>
          <div>{row?.name}</div>
          <small className="text-muted">
            {row?.created_at
              ? moment(row?.created_at).format("DD-MMM-YYYY")
              : "-"}
          </small>
        </div>
      ),
    },
    {
      name: "Total amount",
      selector: (row) => {
        const hasLimit =
          row?.target_amount !== null && row?.target_amount !== 0;
        if (!hasLimit) return "Unlimited";
        return formatMoney(row?.total_amount || "0", true);
      },
    },
    {
      name: "Amount contributed",
      selector: (row) => (
        <span>{formatMoney(row?.amount_contributed || "0", true)}</span>
      ),
    },
    {
      name: "Amount remaining",
      selector: (row) => (
        <div className="">
          {(() => {
            const hasLimit =
              row?.target_amount !== null && row?.target_amount !== 0;
            if (!hasLimit) return "Unlimited";
            const remaining = parseFloat(row?.amount_remaining ?? 0);
            const safeRemaining = isNaN(remaining) ? 0 : Math.max(0, remaining);
            return formatMoney(safeRemaining, true);
          })()}
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown(row)}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },
  ];
};
export const ContributionCategoryHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row, index) => (
        <span className="text-muted fw-bold">{index + 1}</span>
      ),
      width: "70px",
    },
    {
      name: "Contribution name",
      selector: (row) => (
        <div>
          <div className="fw-bold text-dark">{row?.name}</div>
          <small className="text-muted">
            {row?.created_at
              ? moment(row?.created_at).format("DD-MMM-YYYY")
              : "-"}
          </small>
        </div>
      ),
      minWidth: "200px",
    },
    {
      name: "THRESHOLD",
      selector: (row) => (
        <span className="fw-bold text-dark">
          {formatMoney(row?.amount_per_individuals || "0", true)}
        </span>
      ),
      minWidth: "150px",
    },
    {
      name: "BRANCH(S)",
      selector: (row) => (
        <span className="text-dark">{row?.branch?.name || "-"}</span>
      ),
      minWidth: "150px",
    },
    {
      name: "Start date",
      selector: (row) => (
        <span className="text-dark">
          {row?.start_date
            ? moment(row?.start_date).format("DD-MMM-YYYY")
            : "-"}
        </span>
      ),
      width: "130px",
    },
    {
      name: "End date",
      selector: (row) => (
        <span className="text-dark">
          {row?.end_date ? moment(row?.end_date).format("DD-MMM-YYYY") : "-"}
        </span>
      ),
      width: "130px",
    },
    {
      name: "Withdrawable",
      selector: (row) => {
        const isWithdrawable = row?.is_withdrawable === 1 || row?.is_withdrawable === true;
        return (
          <span
            className="px-3 py-1 rounded-pill text-white fw-2"
            style={{
              backgroundColor: isWithdrawable ? "#19BC31" : "#A1A0A0",
              fontSize: "12px",
              display: "inline-block",
              minWidth: "100px",
              textAlign: "center",
            }}
          >
            {isWithdrawable ? "Withdrawable" : "Non-Withdrawable"}
          </span>
        );
      },
      minWidth: "150px",
      center: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown(row)}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },
  ];
};

export const ContributionHistoryData = [
  {
    id: "1",
    con: "Secretariat construction",
    amount: 400000000,
    amountCont: 400000000,
    amountRem: 400000000,
    branch: "Asddls ssjjs sjsj",
    status: "Successful",
    date: "12-04-2022",
    time: "12:30 PM",
    createdAt: "Created on 7-12-2022",
    paymentType: "Flutterwave",
  },
  {
    id: 2,
    con: "Secretariat construction",
    amount: 400000000,
    amountCont: 400000000,
    amountRem: 400000000,
    branch: "Asddls ssjjs sjsj",
    status: "Failed",
    date: "12-04-2022",
    time: "12:30 PM",
    createdAt: "Created on 7-12-2022",
    paymentType: "Flutterwave",
  },
];

export const ContributionBreakDownHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row, index) => (
        <span className="text-muted fw-bold">{index + 1}</span>
      ),
      width: "70px",
    },
    {
      name: "Contributors name",
      selector: (row) => (
        <div>{`${row?.member?.first_name}  ${row?.member?.last_name}`}</div>
      ),
    },
    {
      name: "Amount",
      selector: (row) => formatMoney(row?.amount || "0", true),
    },
    {
      name: "Payment method",
      selector: (row) => <span>{row?.payment_type?.name}</span>,
    },
    {
      name: "Date & Time",
      selector: (row) => (
        <div className="">
          <div>{moment(row?.created_at).format("YYYY-MM-DD")}</div>
          <div className="text-secondary ">
            {moment(row?.created_at).format("HH:mm:ss")}
          </div>
        </div>
      ),
    },
    {
      name: "Status",
      selector: (row) => (
        <div
          className={`${
            true
              ? // row?.status?.toLowerCase() === "successful"
                "text-success"
              : "text-danger"
          }`}
        >
          {/* {convertToTitleCase(row?.status)} */}
        </div>
      ),
    },
  ];
};

export const LoanStatusHeader = (ButtonArray, statusBadgeArray) => {
  return [
    {
      name: "S/N",
      selector: (_, index) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {index + 1}
        </span>
      ),
      width: "80px",
      sortable: false,
    },
    {
      name: "Member Name",
      selector: (row) => (
        <div className="d-flex align-items-center">
          <span className="me-3">
            <FallbackImage
              src={row?.member?.photo}
              width="32px"
              height="32px"
              className="rounded-circle"
              style={{ objectFit: "cover" }}
            />
          </span>
          <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
            {`${row?.member?.first_name || ""} ${row?.member?.last_name || ""}`.trim() || "N/A"}
          </span>
        </div>
      ),
      minWidth: "250px",
      sortable: true,
    },
    {
      name: "Loan Amount",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {formatMoney(row?.amount || 0)}
        </span>
      ),
      minWidth: "150px",
      sortable: true,
      right: true,
    },
    {
      name: "Guarantors",
      selector: (row) => (
        <div className="d-flex flex-wrap gap-2 py-2 align-items-center">
          {row?.guarantors?.length > 0 ? (
            row.guarantors.map((item, index) => (
              <ToolTips
                key={index}
                showText={
                  item.status === "CONFIRMED"
                    ? `${item.name} - Confirmed guarantor`
                    : item.status === "DECLINED"
                    ? `${item.name} - Declined to be guarantor`
                    : `${item.name} - Pending confirmation`
                }
                text={
                  <div
                    className={`d-flex align-items-center ${
                      item.status === "CONFIRMED" ? "" : item.status === "DECLINED" ? "opacity-75" : "opacity-50"
                    }`}
                  >
                    <span className="me-2">
                      <FallbackImage
                        src={item.photo || item.member?.photo}
                        width="28px"
                        height="28px"
                        className="rounded-circle"
                        style={{ objectFit: "cover" }}
                      />
                    </span>
                    <span
                      className="fw-2"
                      style={{
                        fontSize: "13px",
                        color: item.status === "CONFIRMED" 
                          ? "#45464e" 
                          : item.status === "DECLINED"
                          ? "#ff4343"
                          : "#a1a0a0",
                      }}
                    >
                      {item.name || "N/A"}
                    </span>
                    {item.status === "DECLINED" && (
                      <span className="ms-2" style={{ fontSize: "12px", color: "#ff4343" }}>
                        ✗
                      </span>
                    )}
                    {item.status === "CONFIRMED" && (
                      <span className="ms-2" style={{ fontSize: "12px", color: "#19bc31" }}>
                        ✓
                      </span>
                    )}
                  </div>
                }
              />
            ))
          ) : (
            <span className="text-muted" style={{ fontSize: "13px" }}>
              No guarantors
            </span>
          )}
        </div>
      ),
      minWidth: "250px",
      sortable: false,
    },
    {
      name: "Status",
      selector: (row) =>
        statusBadgeArray ? (
          statusBadgeArray(row)
        ) : (
          <span
            className="px-3 py-1 rounded-pill text-white fw-2"
            style={{
              backgroundColor:
                row?.status === "PENDING"
                  ? "#FFA500"
                  : row?.status === "APPROVED"
                  ? "#19BC31"
                  : row?.status === "DECLINED"
                  ? "#FF4343"
                  : row?.status === "DISBURSED"
                  ? "var(--color-secondary)"
                  : "#A1A0A0",
              fontSize: "12px",
              display: "inline-block",
              minWidth: "100px",
              textAlign: "center",
            }}
          >
            {convertToTitleCase(row?.status || "UNKNOWN")}
          </span>
        ),
      minWidth: "130px",
      center: true,
      sortable: true,
    },
    {
      name: "ACTION",
      cell: (row) => {
        const actions = ButtonArray ? ButtonArray(row) : [];

        // If only one action, show as a button directly
        if (actions.length === 1) {
          const singleAction = actions[0];
          return (
            <div className="text-center">
              <ButtonComp
                onClick={() => singleAction.action && singleAction.action(row)}
                btnText={singleAction.name}
                btnClassName="bg-primary1 px-3 fw-2 h6 py-2 text-white rounded"
                style={{ whiteSpace: "nowrap", minWidth: "fit-content" }}
              />
            </div>
          );
        }

        // If multiple actions, show dropdown
        return (
          <div className="text-center">
            <DropDownComp
              dropLabelClassName={"bg-white border-0 px-2 py-1 rounded"}
              arrayComp={actions.map((action) => ({
                ...action,
                aClassName: "px-3 py-2 text-nowrap",
              }))}
              ItemClassName="pe-4 text-2"
              input="name"
              row={row}
              DropDownText={
                <span>
                  <BsThreeDotsVertical size={20} className="table-action-icon" />
                </span>
              }
            />
          </div>
        );
      },
      width: "150px",
    },
  ];
};

export const LoanRepaymentHeader = (dateClassName = "", TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (_, index) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {index + 1}
        </span>
      ),
      width: "80px",
      sortable: false,
    },
    {
      name: "Member Name",
      selector: (row) => (
        <div className="d-flex align-items-center">
          <span className="me-3">
            <FallbackImage
              src={row?.member?.photo}
              width="32px"
              height="32px"
              className="rounded-circle"
              style={{ objectFit: "cover" }}
            />
          </span>
          <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
            {`${row?.member?.first_name || ""} ${row?.member?.last_name || ""}`.trim() || "N/A"}
          </span>
        </div>
      ),
      minWidth: "220px",
      sortable: true,
    },
    {
      name: "Loan Amount",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {formatMoney(row?.amount || 0)}
        </span>
      ),
      minWidth: "150px",
      sortable: true,
      right: true,
    },
    {
      name: "Loan Type",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {row?.loan_type?.name || "N/A"}
        </span>
      ),
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "Due Date / Next Review",
      selector: (row) => {
        const dateStr = row?.due_at ?? row?.next_review_date;
        if (!dateStr) return "N/A";
        const selectedDate = moment(dateStr, "YYYY-MM-DD");
        const today = moment();
        const daysDifference = selectedDate.diff(today, "days");
        const isOverdue = daysDifference < 0;
        const daysDisplay = Math.abs(daysDifference);
        const isReview = !!row?.next_review_date && !row?.due_at;

        let badgeClass = "bg-success2";
        let badgeText = `${daysDisplay} days remaining`;

        if (isOverdue) {
          badgeClass = "bg-danger2";
          badgeText = `${daysDisplay} days overdue`;
        } else if (daysDifference === 0) {
          badgeClass = "bg-warning";
          badgeText = "Due today";
        } else if (daysDifference <= 7) {
          badgeClass = "bg-warning";
          badgeText = `Due in ${daysDisplay} day${daysDisplay > 1 ? "s" : ""}`;
        }
        if (isReview && daysDifference >= 0) badgeText = `Review in ${daysDisplay} day${daysDisplay !== 1 ? "s" : ""}`;
        if (isReview && daysDifference < 0) badgeText = `Review ${daysDisplay} day${daysDisplay !== 1 ? "s" : ""} ago`;

        return (
          <div className="d-flex align-items-center gap-3">
            <BsCalendar2Week size={16} style={{ color: "var(--color-primary)" }} />
            <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
              {moment(dateStr).format("DD-MMM-YYYY")}
              {isReview && (
                <span className="text-muted small ms-1">(review)</span>
              )}
            </span>
            <span
              className={`py-1 px-3 rounded-pill text-black1 fw-2 ${badgeClass}`}
              style={{ fontSize: "11px", whiteSpace: "nowrap" }}
            >
              {badgeText}
            </span>
          </div>
        );
      },
      minWidth: "280px",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown(row)}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span style={{ cursor: "pointer" }}>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
      center: true,
      sortable: false,
    },
  ];
};

export const SettingBranchHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.serialNumber}</span>,
      width: "70px",
    },
    {
      name: "Branch name",
      selector: (row) => (
        <span className="flex items-center">
          <span className="me-3">
            <FallbackImage
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
              src={row?.photo}
              alt="branch logo"
            />
          </span>
          <div>
            <div className="fw-bold">{row?.name}</div>
            <small className="text-muted">
              {row?.country && row?.city
                ? `${row.city}, ${row.country}`
                : "Location not set"}
            </small>
          </div>
        </span>
      ),
      width: "250px",
    },
    {
      name: "Address",
      selector: (row) => (
        <div>
          <div
            className="text-truncate"
            style={{ maxWidth: "200px" }}
            title={row?.address}
          >
            {row?.address?.replace(/ 0$/, "") || row?.address}
          </div>
          {row?.use_cooperative_logo && (
            <small className="text-info">
              <i className="fas fa-building me-1"></i>
              Uses Cooperative Logo
            </small>
          )}
        </div>
      ),
      width: "200px",
    },
    {
      name: "Contact",
      selector: (row) => (
        <div>
          <div className="fw-bold text-primary">{row?.phone}</div>
          <div
            className="text-muted small text-truncate"
            style={{ maxWidth: "150px" }}
            title={row?.email}
          >
            {row?.email}
          </div>
        </div>
      ),
      width: "180px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },
  ];
};

export const SettingCompanyPrefixHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.serialNumber}</span>,
      width: "70px",
    },
    {
      name: "Branch name",
      selector: (row) => (
        <span className="flex items-center">
          <span className="me-3">
            <FallbackImage
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
              src={row?.photo}
            />
          </span>
          {row?.branchName}
        </span>
      ),
      width: "300px",
    },
    {
      name: "Prefix number",
      selector: (row) => row?.prefixNumber,
    },
    {
      name: "Prefix count",
      selector: (row) => row?.prefixCount,
    },
    {
      name: "Auto Generate",
      selector: (row) => (
        <span className={`badge rounded-pill ${row?.autoGenerate?.includes("ON") ? "bg-success" : "bg-secondary"}`}>
          {row?.autoGenerate || "OFF (Sequential)"}
        </span>
      ),
    },
    {
      name: "Date added",
      selector: (row) => (
        <div className="px-3 d-flex align-items-center">{row?.date}</div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },
  ];
};
export const SettingRoleManagementHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.serialNumber}</span>,
      width: "70px",
    },
    {
      name: "Role name",
      selector: (row) => row?.name,
    },
    {
      name: "Permission allowed",
      selector: (row) => (
        <div className="d-flex flex-wrap gap-2">
          {(row?.modules || []).map(({ menu, name }, index) => {
            return (
              <div
                key={`${name}-${index}`}
                className="rounded-pill p-2 h60"
                style={{ background: `${colors[index % colors.length]}` }}
              >
                {name || menu}
              </div>
            );
          })}
          {row?.is_system && (
            <span className="text-muted small align-self-center">
              Full plan access
            </span>
          )}
        </div>
      ),
      width: "400px",
    },

    {
      name: "Date added",
      selector: (row) => (
        <div className="px-3 d-flex align-items-center">
          <span className="me-3"></span>
          {row?.date ?? "N/A"}
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          {row?.is_system ? (
            <span className="text-muted small">System</span>
          ) : (
            <DropDownComp
              dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
              arrayComp={TableDropDown}
              ItemClassName="pe-5 text-2"
              input="name"
              row={row}
              DropDownText={
                <span>
                  <BsThreeDotsVertical size={20} className="table-action-icon" />
                </span>
              }
            />
          )}
        </div>
      ),
      width: "100px",
    },
  ];
};
export const SettingMemberRegistrationFeeHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {row.serialNumber}
        </span>
      ),
      width: "80px",
      sortable: false,
    },
    {
      name: "Fee Name",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {convertToTitleCase(row?.name || "N/A")}
        </span>
      ),
      minWidth: "200px",
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => {
        const isVoluntary = row?.category?.name?.toLowerCase() === "voluntary";
        const amount = row?.amount;
        
        // For voluntary fees, if amount is null/undefined, show "Variable"
        if (isVoluntary && (amount === null || amount === undefined || amount === "")) {
          return (
            <span className="fw-2 text-blacklight" style={{ fontSize: "14px" }}>
              Variable
            </span>
          );
        }
        
        // For other fees or voluntary fees with amount, show formatted amount
        if (amount !== null && amount !== undefined && amount !== "") {
          return (
            <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
              {formatMoney(amount)}
            </span>
          );
        }
        
        // Fallback for null amounts in non-voluntary fees
        return (
          <span className="fw-2 text-blacklight" style={{ fontSize: "14px" }}>
            N/A
          </span>
        );
      },
      minWidth: "150px",
      sortable: true,
      right: true,
    },
    {
      name: "Status",
      selector: (row) => {
        const status = row?.category?.name || "";
        const isCompulsory = status?.toLowerCase() === "compulsory";
        return (
          <span
            className="px-3 py-1 rounded-pill text-white fw-2"
            style={{
              backgroundColor: isCompulsory ? "#FF9500" : "var(--color-secondary)",
              fontSize: "12px",
              display: "inline-block",
              minWidth: "100px",
              textAlign: "center",
            }}
          >
            {convertToTitleCase(status || "N/A")}
          </span>
        );
      },
      minWidth: "130px",
      center: true,
      sortable: true,
    },
    {
      name: "Date Added",
      selector: (row) => (
        <div className="d-flex align-items-center">
          <BsCalendar2Week className="me-2" size={16} style={{ color: "var(--color-primary)" }} />
          <span className="text-black1 fw-2" style={{ fontSize: "14px" }}>
            {row?.date || "N/A"}
          </span>
        </div>
      ),
      minWidth: "160px",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span style={{ cursor: "pointer" }}>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
      center: true,
      sortable: false,
    },
  ];
};
export const SettingSocietyBankInformationHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.serialNumber}</span>,
      width: "70px",
    },
    {
      name: "Bank name",
      selector: (row) => row?.bank_name,
    },
    {
      name: "Account name",
      selector: (row) => row?.account_name,
    },
    {
      name: "Account number",
      selector: (row) => row?.account_number,
    },

    {
      name: "Date added",
      selector: (row) => (
        <div className="px-3 d-flex align-items-center">
          <span className="me-3"></span>
          {row?.date}
        </div>
      ),
    },
    {
      name: "Payout status",
      width: "150px",
      selector: (row) =>
        row?.paystack_recipient_code ? (
          <span className="badge rounded-pill bg-success">Ready for payouts</span>
        ) : (
          <span className="badge rounded-pill bg-warning text-dark">Recipient not configured</span>
        ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center d-flex justify-content-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-2 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-4 text-2"
            input="name"
            row={row}
            align="end"
            DropDownText={
              <span
                className="d-inline-flex align-items-center justify-content-center rounded-circle"
                style={{
                  width: 32,
                  height: 32,
                  background: "var(--color-primary-soft)",
                }}
                aria-label="Account actions"
              >
                <BsThreeDotsVertical size={16} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
};
export const EventManagementHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.serialNumber}</span>,
      width: "70px",
    },
    {
      name: "Event name",
      selector: (row) => row?.name,
    },
    {
      name: "Description",
      selector: (row) => (
        <div
          className="text-wrap"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxHeight: "3em",
            lineHeight: "1.5em",
          }}
        >
          {row?.description}
        </div>
      ),
      width: "250px",
    },
    {
      name: "Start date",
      selector: (row) => row?.start_date,
      width: "130px",
    },

    {
      name: "End date",
      selector: (row) => row?.end_date,
      width: "130px",
    },
    {
      name: "Duration",
      selector: (row) => <span>{row?.duration} hours</span>,
    },
    {
      name: "Venue",
      selector: (row) => <div className="text-wrap">{row?.address}</div>,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={
              typeof TableDropDown === "function"
                ? TableDropDown(row)
                : TableDropDown
            }
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },

    // {
    //   name: "",
    //   selector: (row) => <div onClick={()=>router.push(`/sales/${type}/${row.id}`)}><BsThreeDots size={25}/></div>,
    //   width:'70px'
    // },
  ];
};
export const AttendanceHeader = (
  attendanceMarker,
  attendance_statuses = [],
  attendance = []
) => {
  return [
    {
      name: "S/N",
      selector: (row) => (
        <div className="p-2 text-center">
          <span className="text-muted pl-2 w-100">{row?.serialNumber}</span>
        </div>
      ),
      width: "70px",
    },
    {
      name: "Member name",
      selector: (row) => (
        <span className="flex items-center" style={{ paddingLeft: "10px" }}>
          <span className="me-3">
            <FallbackImage
              src={row?.photo}
              width="30px"
              height="30px"
              className="rounded-circle"
            />
          </span>
          <span>{row?.name || ""}</span>
        </span>
      ),
      width: "200px",
    },
    {
      name: "Attendance status",
      selector: (row) => {
        // Find the selected attendance status for this member
        const memberAttendance = attendance.find(
          (item) => String(item.member_id) === String(row?.id)
        );
        const selectedStatusId = memberAttendance?.attendance_status_id;

        return (
          <div className="d-flex">
            {attendance_statuses.map((attendance_status) => {
              const isChecked =
                selectedStatusId &&
                String(selectedStatusId) === String(attendance_status?.id);
              const isNonApprovedAbsent = String(attendance_status?.name).toLowerCase().includes("non-approved") || 
                                          String(attendance_status?.name).toLowerCase().includes("fine");
              
              return (
                <div
                  className={`border-end border-2 p-3 ${isChecked && isNonApprovedAbsent ? "bg-danger bg-opacity-10" : ""}`}
                  key={attendance_status?.name}
                  style={{ transition: "all 0.3s ease" }}
                >
                  <CustomRadioComp
                    name={row?.id}
                    value={attendance_status?.id}
                    labelText={
                      <div className="d-flex flex-column">
                        <span>{attendance_status?.name}</span>
                        {isNonApprovedAbsent && (
                          <small className="text-danger fw-bold" style={{ fontSize: "10px" }}>
                            FINE APPLIES
                          </small>
                        )}
                      </div>
                    }
                    checked={isChecked}
                    onValueChange={() =>
                      attendanceMarker(row?.id, attendance_status?.id)
                    }
                  />
                </div>
              );
            })}
          </div>
        );
      },
    },
  ];
};
export const AttendanceHistoryHeader = (single = false, onEditEntry) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.serialNumber}</span>,
      width: "70px",
    },
    {
      name: single ? "Month" : "Member name",
      selector: (row) => (
        <span className="d-flex align-items-center" style={{ paddingLeft: "10px" }}>
          {single ? (
            <span className="fw-semibold">{row?.month}</span>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <FallbackImage
                src={row?.member?.photo}
                width="32px"
                height="32px"
                className="rounded-circle border"
              />
              <div className="d-flex flex-column">
                <span className="fw-semibold text-black1">
                  {row?.member?.first_name || ""} {row?.member?.last_name || ""}
                </span>
                <span className="text-muted" style={{ fontSize: "11px" }}>
                  {row?.member?.member_no || "N/A"}
                </span>
              </div>
            </div>
          )}
        </span>
      ),
      width: "220px",
    },
    {
      name: "Attendance Status",
      cell: (row) => {
        const { attendanceStatus = [] } = row;
        return (
          <div
            className="d-flex align-items-center gap-2 flex-wrap"
            style={{ padding: "8px 10px" }}
          >
            {attendanceStatus.length > 0 ? (
              attendanceStatus.map((item, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => onEditEntry && onEditEntry(item, row?.member)}
                    title={`Click to edit: ${item.status_name || item.status || "Attendance"}`}
                    className="d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "10px",
                      background: "#fff",
                      border: "1px solid #E5E5E5",
                      cursor: onEditEntry ? "pointer" : "default",
                      transition: "all 0.2s ease",
                      position: "relative"
                    }}
                    onMouseOver={(e) => { if(onEditEntry) e.currentTarget.style.borderColor = "var(--color-primary)"; }}
                    onMouseOut={(e) => { if(onEditEntry) e.currentTarget.style.borderColor = "#E5E5E5"; }}
                  >
                    <span style={{ fontSize: "10px", color: "#888", fontWeight: "600", marginBottom: "2px" }}>
                      {item.date}
                    </span>
                    <FallbackImage
                      src={item?.icon}
                      width="20px"
                      height="20px"
                    />
                  </div>
                );
              })
            ) : (
              <span className="text-muted small">No records</span>
            )}
          </div>
        );
      },
      minWidth: "350px",
    },
    {
      name: "Summary",
      width: "200px",
      selector: ({ attendanceCount }) => (
        <div
          className="d-flex gap-2 align-items-center"
          style={{ paddingLeft: "10px" }}
        >
          <div 
            className="px-2 py-1 rounded d-flex align-items-center gap-1"
            style={{ background: "rgba(25, 188, 49, 0.1)", color: "#19BC31" }}
          >
            <span className="fw-bold" style={{ fontSize: "12px" }}>{attendanceCount?.present || 0}</span>
            <span style={{ fontSize: "10px" }}>Present</span>
          </div>
          <div 
            className="px-2 py-1 rounded d-flex align-items-center gap-1"
            style={{ background: "rgba(255, 67, 67, 0.1)", color: "#FF4343" }}
          >
            <span className="fw-bold" style={{ fontSize: "12px" }}>{attendanceCount?.absent || 0}</span>
            <span style={{ fontSize: "10px" }}>Absent</span>
          </div>
        </div>
      ),
    },
    {
      name: "Action",
      width: "120px",
      right: true,
      cell: (row) => {
        const { viewAll } = row;
        return (
          single === false && (
            <ButtonComp
              btnText={"View History"}
              btnClassName={"px-3 py-1 text-primary1 bg-white rounded border border-primary1"}
              style={{ whiteSpace: "nowrap", fontSize: "12px", minWidth: "100px" }}
              onClick={() => viewAll && viewAll()}
            />
          )
        );
      }
    }
  ];
};

// Per-entry rows for member detail (one row per attendance)
export const MemberAttendanceEntriesHeader = () => {
  const statusColor = (id) => {
    if (id === 1) return { bg: "rgba(25, 188, 49, 0.1)", color: "#19BC31" }; // Present & Early
    if (id === 2) return { bg: "rgba(218, 105, 0, 0.1)", color: "#DA6900" }; // Present, But Late
    if (id === 3) return { bg: "var(--color-secondary-soft)", color: "var(--color-secondary)" }; // Approve Absent
    return { bg: "rgba(255, 67, 67, 0.1)", color: "#FF4343" }; // Non-Approved Absent
  };

  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted small">{row.serialNumber}</span>,
      width: "60px",
    },
    {
      name: "Date",
      selector: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold text-black1">
            {row?.date || ""}
          </span>
          <span className="text-muted small" style={{ fontSize: "11px" }}>
            {row?.week_day || ""}
          </span>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Month",
      selector: (row) => <span className="text-muted small fw-medium">{row?.month}</span>,
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => {
        const style = statusColor(row?.status_id);
        return (
          <span
            className="px-3 py-1 rounded-pill fw-semibold"
            style={{ 
              background: style.bg, 
              color: style.color, 
              fontSize: "12px",
              border: `1px solid ${style.color}33`
            }}
          >
            {row?.status_name || "Unknown"}
          </span>
        );
      },
      minWidth: "150px",
    },
    {
      name: "Action",
      right: true,
      cell: (row) => (
        <div className="text-center">
          <ButtonComp
            btnText={row.isLocked ? "Locked" : "Change Status"}
            btnClassName={`${row.isLocked ? "text-muted bg-light" : "text-primary1 bg-white border-primary1"} px-3 py-1 rounded border small`}
            style={{ fontSize: "11px", minWidth: "100px", opacity: row.isLocked ? 0.6 : 1 }}
            onClick={() => !row.isLocked && row.onEdit && row.onEdit(row)}
            disabled={row.isLocked}
          />
        </div>
      ),
      width: "140px",
    },
  ];
};

export const MemberLoanStatusHeader = (onViewDetails, onViewRepaymentPlan, tabName = "") => {
  return [
    {
      name: "S/N",
      selector: (_, index) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {index + 1}
        </span>
      ),
      width: "70px",
    },
    {
      name: "Loan name",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {row?.loan_type?.name || "N/A"}
        </span>
      ),
      width: "200px",
    },
    {
      name: "Loan amount",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {formatMoney(row?.amount || 0)}
        </span>
      ),
      minWidth: "150px",
    },
    {
      name: "Status",
      selector: (row) => (
        <div
          className="px-3 py-1 rounded-pill text-white text-center"
          style={{
            backgroundColor:
              row?.status === "PENDING"
                ? "#FFA500"
                : row?.status === "APPROVED"
                ? "#19BC31"
                : row?.status === "DECLINED"
                ? "#FF4343"
                : row?.status === "DISBURSED"
                ? "var(--color-secondary)"
                : "#A1A0A0",
            fontSize: "12px",
            minWidth: "100px",
          }}
        >
          {convertToTitleCase(row?.status || "UNKNOWN")}
        </div>
      ),
      minWidth: "120px",
    },
    {
      name: "Repayment plan",
      selector: (row) => (
        <span className="text-black1" style={{ fontSize: "14px" }}>
          {convertToTitleCase(row?.repayment_plan || "N/A")}
        </span>
      ),
      minWidth: "150px",
    },
    {
      name: "Date",
      selector: (row) => (
        <span className="text-black1" style={{ fontSize: "14px" }}>
          {row?.updated_at
            ? moment(row.updated_at).format("DD-MMM-YYYY")
            : "N/A"}
        </span>
      ),
      minWidth: "120px",
    },
    {
      name: "Actions",
      cell: (row) => {
        const actions = [];
        
        // Always show "View Details" for all loan statuses
        if (onViewDetails) {
          actions.push({
            name: "View Details",
            action: () => onViewDetails(row?.id),
          });
        }
        
        // Show "View Repayment Plan" for all loans (disbursed and paid) so members can always see repayment breakdown; paid loans show read-only completed state
        const loanId = row?.id ?? row?.loan_request?.id;
        if (loanId && onViewRepaymentPlan) {
          actions.push({
            name: "View Repayment Plan",
            action: () => onViewRepaymentPlan(loanId),
          });
        } else if (loanId) {
          actions.push({
            name: "View Repayment Plan",
            action: () => {
              window.location.href = `/member/loan_management/repayment/${loanId}`;
            },
          });
        }
        
        // Ensure actions array is never empty - if no handlers, provide default action
        if (actions.length === 0) {
          actions.push({
            name: "View Details",
            action: () => {
              if (onViewDetails) {
                onViewDetails(row?.id);
              }
            },
          });
        }

        const dropdownId = `loan-status-actions-${row?.id || Math.random().toString(36).substring(2, 9)}`;

        // Single action: show as a visible button so the dropdown is not needed
        if (actions.length === 1) {
          const single = actions[0];
          return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40px" }}>
              <ButtonComp
                btnText={single.name}
                btnClassName="bg-white border border-secondary text-primary1 px-3 py-1 rounded"
                onClick={single.action}
                style={{ whiteSpace: "nowrap", minWidth: "fit-content", fontSize: "13px" }}
              />
            </div>
          );
        }

        // Multiple actions: use dropdown
        return (
          <div 
            className="text-center d-flex justify-content-center align-items-center" 
            style={{ 
              minWidth: "80px",
              minHeight: "40px",
              position: "relative",
            }}
          >
            <DropDownComp
              dropdownId={dropdownId}
              dropLabelClassName={"bg-white border-0 px-2 py-1 rounded-4"}
              arrayComp={actions}
              ItemClassName="pe-4 text-2"
              input="name"
              row={row}
              drop="down"
              DropDownText={
                <span 
                  style={{ 
                    cursor: "pointer", 
                    display: "inline-flex", 
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "4px 8px",
                    minWidth: "32px",
                    minHeight: "32px",
                  }}
                >
                  <BsThreeDotsVertical size={20} className="table-action-icon" />
                </span>
              }
            />
          </div>
        );
      },
      width: "100px",
      minWidth: "100px",
      wrap: false,
    },
  ];
};

export const MemberWithdrawalRequestsHeader = (TableDropDown) => {
  // Get status badge color
  const getStatusColor = (status) => {
    const statusUpper = (status || "").toUpperCase();
    if (statusUpper === "PAID" || statusUpper === "APPROVED") {
      return "#19BC31"; // Green
    }
    if (statusUpper === "PENDING") {
      return "#FFA500"; // Orange
    }
    if (statusUpper === "DECLINED" || statusUpper === "CANCELED") {
      return "#FF4343"; // Red
    }
    return "#A1A0A0"; // Grey
  };

  return [
    {
      name: "S/N",
      selector: (row, index) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {index + 1}
        </span>
      ),
      width: "70px",
    },
    {
      name: "Request Date",
      selector: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
            {moment(row?.created_at || row?.request_date).format("DD-MMM-YYYY")}
          </span>
          <span className="text-muted small" style={{ fontSize: "12px" }}>
            {moment(row?.created_at || row?.request_date).format("hh:mm A")}
          </span>
        </div>
      ),
      minWidth: "150px",
    },
    {
      name: "Amount",
      selector: (row) => (
        <span className="fw-bold text-black1" style={{ fontSize: "14px" }}>
          {formatMoney(row?.amount || 0, true, "₦")}
        </span>
      ),
      minWidth: "150px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = row?.status || "PENDING";
        return (
          <span
            className="px-3 py-1 rounded-pill text-white fw-semibold"
            style={{
              backgroundColor: getStatusColor(status),
              fontSize: "12px",
              whiteSpace: "nowrap",
              display: "inline-block",
            }}
          >
            {convertToTitleCase(status)}
          </span>
        );
      },
      minWidth: "120px",
    },
    {
      name: "Bank Account",
      selector: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
            {row?.bank_account?.bank_name || row?.bank_account?.bank?.name || row?.bank_name || "N/A"}
          </span>
          <span className="text-muted small" style={{ fontSize: "12px" }}>
            {row?.bank_account?.account_number || row?.account_number || ""}
          </span>
        </div>
      ),
      minWidth: "180px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ minWidth: "100px" }}>
          {TableDropDown && typeof TableDropDown === "function" && (
            <DropDownComp
              row={row}
              DropDownText={
                <span>
                  <BsThreeDotsVertical size={20} className="table-action-icon" />
                </span>
              }
              arrayComp={TableDropDown(row)}
              input="name"
            />
          )}
        </div>
      ),
      width: "100px",
    },
  ];
};

export const AdminWithdrawalRequestsHeader = (actionHandlers) => {
  // Get status badge color
  const getStatusColor = (status) => {
    const statusUpper = (status || "").toUpperCase();
    if (statusUpper === "PAID" || statusUpper === "APPROVED") {
      return "#19BC31"; // Green
    }
    if (statusUpper === "PENDING") {
      return "#FFA500"; // Orange
    }
    if (statusUpper === "DECLINED" || statusUpper === "CANCELED") {
      return "#FF4343"; // Red
    }
    return "#A1A0A0"; // Grey
  };

  return [
    {
      name: "S/N",
      selector: (row, index) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {index + 1}
        </span>
      ),
      width: "70px",
    },
    {
      name: "Member",
      selector: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold text-black1" style={{ fontSize: "14px" }}>
            {row?.member?.first_name && row?.member?.last_name
              ? `${row?.member?.first_name} ${row?.member?.last_name}`
              : row?.member?.name || "-"}
          </span>
          <span className="text-muted small" style={{ fontSize: "12px" }}>
            {row?.member?.member_no ? `#${row?.member?.member_no}` : row?.member?.email || ""}
          </span>
        </div>
      ),
      minWidth: "180px",
    },
    {
      name: "Request Date",
      selector: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
            {moment(row?.created_at || row?.request_date).format("DD-MMM-YYYY")}
          </span>
          <span className="text-muted small" style={{ fontSize: "12px" }}>
            {moment(row?.created_at || row?.request_date).format("hh:mm A")}
          </span>
        </div>
      ),
      minWidth: "150px",
    },
    {
      name: "Amount",
      selector: (row) => (
        <span className="fw-bold text-black1" style={{ fontSize: "14px" }}>
          {formatMoney(row?.amount || 0, true, "₦")}
        </span>
      ),
      minWidth: "150px",
    },
    {
      name: "Bank Account",
      selector: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
            {row?.bank_account?.bank_name || row?.bank_account?.bank?.name || row?.bank_name || "N/A"}
          </span>
          <span className="text-muted small" style={{ fontSize: "12px" }}>
            {row?.bank_account?.account_number || row?.account_number || ""}
          </span>
        </div>
      ),
      minWidth: "180px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = row?.status || "PENDING";
        return (
          <span
            className="px-3 py-1 rounded-pill text-white fw-semibold"
            style={{
              backgroundColor: getStatusColor(status),
              fontSize: "12px",
              whiteSpace: "nowrap",
              display: "inline-block",
              minWidth: "100px",
            }}
          >
            {convertToTitleCase(status)}
          </span>
        );
      },
      minWidth: "120px",
    },
    {
      name: "Actions",
      cell: (row) => {
        const status = (row?.status || "PENDING").toUpperCase();
        const handlers = actionHandlers && typeof actionHandlers === "function" ? actionHandlers(row) : actionHandlers || {};
        
        return (
          <div 
            className="d-flex align-items-center gap-2" 
            style={{ 
              minWidth: "fit-content",
              whiteSpace: "nowrap",
              justifyContent: "flex-start",
              padding: "0 10px",
            }}
          >
            {handlers.onViewDetails && (
              <button
                onClick={() => handlers.onViewDetails(row.id)}
                className="btn btn-sm"
                style={{
                  backgroundColor: "var(--color-secondary)",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "5px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  minWidth: "fit-content",
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor =
                    "color-mix(in srgb, var(--color-secondary) 80%, black)")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "var(--color-secondary)")}
              >
                View
              </button>
            )}
            {status === "PENDING" && handlers.onApprove && (
              <button
                onClick={() => {
                  // Double-check status before proceeding
                  if (row.status?.toUpperCase() !== "PENDING") {
                    return;
                  }
                  handlers.onApprove(row.id);
                }}
                className="btn btn-sm"
                style={{
                  backgroundColor: "#19BC31",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "5px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  minWidth: "fit-content",
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#158a26")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#19BC31")}
              >
                Approve
              </button>
            )}
            {status === "PENDING" && handlers.onDecline && (
              <button
                onClick={() => {
                  // Double-check status before proceeding
                  if (row.status?.toUpperCase() !== "PENDING") {
                    return;
                  }
                  handlers.onDecline(row.id);
                }}
                className="btn btn-sm"
                style={{
                  backgroundColor: "#FF4343",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "5px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  minWidth: "fit-content",
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#d40000")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#FF4343")}
              >
                Decline
              </button>
            )}
            {status === "APPROVED" && handlers.onMarkAsPaid && (
              <button
                onClick={() => {
                  // Double-check status before proceeding
                  if (row.status?.toUpperCase() !== "APPROVED") {
                    return;
                  }
                  handlers.onMarkAsPaid(row.id);
                }}
                className="btn btn-sm"
                style={{
                  backgroundColor: "#19BC31",
                  color: "#ffffff",
                  border: "none",
                  borderRadius: "5px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  minWidth: "fit-content",
                }}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#158a26")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#19BC31")}
              >
                Mark as Paid
              </button>
            )}
          </div>
        );
      },
      minWidth: "280px",
      width: "auto",
      grow: 0,
      wrap: false,
    },
  ];
};

export const MemberLoanRepaymentHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (_, index) => <span className="text-muted">{index + 1}</span>,
      width: "70px",
    },
    {
      name: "Loan Type",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {row?.loan_type?.name || row?.loan_request?.loan_type?.name || "N/A"}
        </span>
      ),
      width: "200px",
    },
    {
      name: "Loan amount",
      selector: (row) => {
        const paid = parseFloat(row?.amount_paid || 0);
        const left = row?.balance ?? Math.max(0, parseFloat(row?.amount || 0) - paid);
        return (
          <div className="d-flex flex-column">
            <span className="">{formatMoney(row.amount || "00")}</span>
            {paid > 0 && (
              <span className="text-muted small">
                Balance {formatMoney(left)}
              </span>
            )}
          </div>
        );
      },
    },
    {
      name: "Due Date / Next Review",
      selector: (row) => {
        const dueDate = row?.due_at || row?.next_due_date || row?.next_review_date;
        if (!dueDate) return <span className="text-muted">N/A</span>;

        const selectedDate = moment(dueDate, "YYYY-MM-DD");
        const today = moment().startOf("day");
        const daysDifference = selectedDate.diff(today, "days");
        const isOverdue = daysDifference < 0;
        const isDueSoon = daysDifference >= 0 && daysDifference <= 7;
        const daysText = Math.abs(daysDifference) === 1 ? "day" : "days";
        const isReview = !!row?.next_review_date && !row?.due_at && !row?.next_due_date;

        const status = (row?.status || row?.repayment_status || "PENDING").toUpperCase();
        const isPaid = status === "PAID" || status === "COMPLETED";
        const shouldShowBadge = !isPaid && (isOverdue || isDueSoon);

        let badgeText = isOverdue
          ? `${Math.abs(daysDifference)} ${daysText} overdue`
          : `Due in ${daysDifference} ${daysText}`;
        if (isReview && shouldShowBadge)
          badgeText = isOverdue
            ? `Review ${Math.abs(daysDifference)} ${daysText} ago`
            : `Review in ${daysDifference} ${daysText}`;

        return (
          <div className="d-flex flex-column gap-1">
            <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
              {moment(dueDate).format("DD-MMM-YYYY")}
              {isReview && (
                <span className="text-muted small ms-1">(review)</span>
              )}
            </span>
            {shouldShowBadge && (
              <span
                className="px-2 py-1 rounded-pill text-white small"
                style={{
                  backgroundColor: isOverdue ? "#FF4343" : "#FFA500",
                  fontSize: "10px",
                  width: "fit-content",
                }}
              >
                {badgeText}
              </span>
            )}
          </div>
        );
      },
      minWidth: "180px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = row?.status || row?.repayment_status || "UNKNOWN";
        const statusColor =
          status === "OVERDUE"
            ? "#FF4343"
            : status === "PAID" || status === "COMPLETED"
            ? "#19BC31"
            : status === "PENDING"
            ? "#FFA500"
            : "#A1A0A0";

        return (
          <div
            className="px-3 py-1 rounded-pill text-white text-center"
            style={{
              backgroundColor: statusColor,
              fontSize: "12px",
              minWidth: "100px",
            }}
          >
            {convertToTitleCase(status)}
          </div>
        );
      },
      width: "120px",
    },
    {
      name: "GUARANTOR",
      selector: (row) => (
        <MemberLoanRepaymentGuarantorsCell
          guarantors={row?.guarantors || row?.loan_request?.guarantors || []}
        />
      ),
      minWidth: "150px",
    },
    {
      name: "Actions",
      cell: (row) => {
        // If TableDropDown is a function, call it with the row status to get actions
        // Otherwise, use it as an array directly
        let actions = [];
        if (typeof TableDropDown === 'function') {
          // Try multiple possible status field names
          const status = row?.status || row?.repayment_status || row?.breakdown_status || "PENDING";
          actions = TableDropDown(status);
        } else if (Array.isArray(TableDropDown)) {
          actions = TableDropDown;
        }
        
        // Ensure actions array has items, otherwise show empty dropdown
        if (actions.length === 0) {
          return (
            <div className="text-center">
              <span style={{ color: "#a1a0a0" }}>-</span>
            </div>
          );
        }
        
        return (
          <div className="text-center">
            <DropDownComp
              dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
              arrayComp={actions}
              ItemClassName="pe-5 text-2"
              input="name"
              row={row}
              DropDownText={
                <span>
                  <BsThreeDotsVertical size={20} className="table-action-icon" />
                </span>
              }
            />
          </div>
        );
      },
      width: "100px",
    },

    // {
    //   name: "",
    //   selector: (row) => <div onClick={()=>router.push(`/sales/${type}/${row.id}`)}><BsThreeDots size={25}/></div>,
    //   width:'70px'
    // },
  ];
};
export const MemberLoanRepaymentHeader2 = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.id}</span>,
      width: "70px",
    },
    {
      name: "Loan name",
      selector: (row) => <span style={{ width: "50px" }}>Personal Loan</span>,
      width: "200px",
    },
    {
      name: "Loan amount",
      selector: (row) => (
        <span className="">{formatMoney(row.amount || "00")}</span>
      ),
    },
    {
      name: "Guarantor's",
      selector: (row) => (
        <div className="d-flex gap-3 h50">
          <div>Adebayo Salako,</div> <div>Adebayo Salako</div>
        </div>
      ),
      width: "300px",
    },
    {
      name: "Repayment plan",
      selector: (row) => (
        <span className="h50 d-flex  align-items-center">
          <ButtonComp
            btnText={"Pay now"}
            btnClassName="bg-primary1 text-white px-3 rounded py-2"
          />
        </span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },

    // {
    //   name: "",
    //   selector: (row) => <div onClick={()=>router.push(`/sales/${type}/${row.id}`)}><BsThreeDots size={25}/></div>,
    //   width:'70px'
    // },
  ];
};
export const MemberContributionsHistory = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.id}</span>,
      width: "70px",
    },
    {
      name: "Contribution name",
      selector: (row) => <span style={{ width: "50px" }}>{row?.name}</span>,
      width: "200px",
    },
    {
      name: "Loan amount",
      selector: (row) => (
        <span className="">{formatMoney(row.amount || "00")}</span>
      ),
    },
    {
      name: "Payment method",
      selector: (row) => (
        <div className="d-flex gap-3 h50">
          {row?.paymentType || "FlutterWave"}
        </div>
      ),
      // width:'300px'
    },
    {
      name: "Date & Time",
      selector: (row) => (
        <span className="h50">
          <div>{row?.date}</div>

          <div>{row?.time ?? "—"}</div>
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) => (
        <span className="h50 text-success1">{"Successful"}</span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },

    // {
    //   name: "",
    //   selector: (row) => <div onClick={()=>router.push(`/sales/${type}/${row.id}`)}><BsThreeDots size={25}/></div>,
    //   width:'70px'
    // },
  ];
};
export const MemberUpcomingContributions = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.id}</span>,
      width: "70px",
    },
    {
      name: "Contribution name",
      selector: (row) => <span style={{ width: "50px" }}>{row?.name}</span>,
      width: "200px",
    },
    {
      name: "Loan amount",
      selector: (row) => (
        <span className="">{formatMoney(row.amount || "00")}</span>
      ),
    },
    {
      name: "Amount paid",
      selector: (row) => <span className="">{formatMoney("00")}</span>,
    },

    {
      name: "Due date",
      selector: (row) => (
        <span className="h50">
          <div>{row?.date}</div>
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) => (
        <span className="h50 d-flex  align-items-center">
          <ButtonComp
            btnText={"Pay now"}
            btnClassName="bg-primary1 text-white px-3 rounded py-2"
          />
        </span>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },

    // {
    //   name: "",
    //   selector: (row) => <div onClick={()=>router.push(`/sales/${type}/${row.id}`)}><BsThreeDots size={25}/></div>,
    //   width:'70px'
    // },
  ];
};
export const MemberEventHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <p className="text-muted">{row.id}</p>,
      width: "70px",
    },
    {
      name: "Event name",
      selector: (row) => <p>{row?.name}</p>,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => <p className="">{row?.description}</p>,
      width: "250px",
    },

    {
      name: "Start date",
      selector: (row) => (
        <div className="h50">
          <p>{row?.start_date}</p>
        </div>
      ),
    },

    {
      name: "End date",
      selector: (row) => (
        <div className="h50">
          <p>{row?.end_date}</p>
        </div>
      ),
    },
    {
      name: "Duration",
      cell: (row) => (
        <div className="h50 text-wrap text-center">
          <p>{row?.duration}</p>
        </div>
      ),
      width: "50px",
    },
    {
      name: "Venue",
      selector: (row) => (
        <div className="h50 text-wrap">
          <p className="">{row?.address}</p>
        </div>
      ),
      minWidth: "200px",
    },

    {
      name: "Actions",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },

    // {
    //   name: "",
    //   selector: (row) => <div onClick={()=>router.push(`/sales/${type}/${row.id}`)}><BsThreeDots size={25}/></div>,
    //   width:'70px'
    // },
  ];
};
export const MemberAttendanceHistoryHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.id}</span>,
      width: "70px",
    },
    {
      name: "Meeting name",
      selector: (row) => (
        <span className="" style={{ width: "50px" }}>
          {"Annual meeting"}
        </span>
      ),
      width: "200px",
    },
    {
      name: "Date",
      selector: (row) => <span className="text-wrap">{row?.desc}</span>,
    },

    {
      name: "Status",
      selector: (row) => (
        <span className="h50">
          <div>
            <span>
              <FallbackImage src="/Icon/tick-circle-success.svg" />
            </span>{" "}
            <span className="h60">Present and early</span>
          </div>
        </span>
      ),
    },

    {
      name: "Actions",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },

    // {
    //   name: "",
    //   selector: (row) => <div onClick={()=>router.push(`/sales/${type}/${row.id}`)}><BsThreeDots size={25}/></div>,
    //   width:'70px'
    // },
  ];
};
export const SettingFineSettingHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row, index) => <span className="text-muted">{index + 1}</span>,
      width: "70px",
    },
    {
      name: "Fine Name",
      selector: (row) => <span className="fw-bold">{row?.name}</span>,
      minWidth: "160px",
    },
    {
      name: "Category",
      selector: (row) => (
        <span className="px-2 py-1 rounded bg-info bg-opacity-10 text-info small fw-bold">
          {row?.category_name || row?.category?.name || row?.fine_category?.name || "Other"}
        </span>
      ),
      minWidth: "130px",
    },
    {
      name: "Amount",
      selector: (row) => <div className="fw-bold text-dark">{formatMoney(row?.amount || 0)}</div>,
      minWidth: "110px",
    },
    {
      name: "Status",
      selector: (row) => {
        if (row.isNew) {
          return (
            <div className="d-flex align-items-center gap-2">
              <span 
                className="px-2 py-1 rounded text-muted bg-light border"
                style={{ fontSize: "11px", fontStyle: "italic" }}
              >
                Not Configured
              </span>
            </div>
          );
        }
        
        const isActive = row.is_active === 1;
        return (
          <div className="d-flex align-items-center gap-3">
            <div 
              onClick={(e) => {
                e.stopPropagation();
                row.onToggle && row.onToggle(row);
              }}
              title={isActive ? "Click to disable" : "Click to enable"}
              style={{
                width: '46px',
                height: '24px',
                backgroundColor: isActive ? '#19BC31' : '#A1A0A0',
                borderRadius: '24px',
                position: 'relative',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.15)'
              }}
            >
              <div style={{
                width: '18px',
                height: '18px',
                backgroundColor: 'white',
                borderRadius: '50%',
                position: 'absolute',
                top: '3px',
                left: isActive ? '25px' : '3px',
                transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
              }} />
            </div>
            <span
              className="fw-bold"
              style={{
                color: isActive ? "#19BC31" : "#45464e",
                fontSize: "12px",
                minWidth: "55px",
              }}
            >
              {isActive ? "Active" : "Disabled"}
            </span>
          </div>
        );
      },
      minWidth: "160px",
    },
    {
      name: "Date Added",
      selector: (row) => (
        <div className="small text-muted">
          {row?.date_added ? moment(row.date_added).format("DD-MMM-YYYY") : "N/A"}
        </div>
      ),
      width: "120px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={typeof TableDropDown === "function" ? TableDropDown(row) : TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },
  ];
};

export const ViewMembersHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => (
        <span className="fw-bold text-black">{row.serialNumber}</span>
      ),
      width: "70px",
    },
    {
      name: "Name",
      selector: (row) => (
        <div className="d-flex align-items-center">
          <span className="me-3">
            <FallbackImage
              src={row?.photo}
              width="32px"
              height="32px"
              className="rounded-circle"
              style={{ objectFit: "cover" }}
            />
          </span>
          <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
            {row?.name || "N/A"}
          </span>
        </div>
      ),
      minWidth: "220px",
      sortable: true,
    },
    {
      name: "Phone number",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {row?.phone || "N/A"}
        </span>
      ),
      minWidth: "140px",
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {row?.email || "N/A"}
        </span>
      ),
      minWidth: "180px",
      sortable: true,
    },
    {
      name: "Branch",
      selector: (row) => (
        <div className="d-flex align-items-center">
          <span
            style={{ 
              background: "var(--color-secondary-soft)", 
              color: "var(--color-secondary)",
              fontSize: "12px",
              minWidth: "fit-content"
            }}
            className="px-3 py-1 rounded-pill fw-semibold"
          >
            {row?.branch || "N/A"}
          </span>
        </div>
      ),
      minWidth: "180px",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => {
        // Check both is_suspended and is_active fields for compatibility
        const isActive = row?.is_active !== false && !row?.is_suspended;
        const statusText = isActive ? "Active" : "Not Active";
        return (
          <span
            style={{
              backgroundColor: isActive ? "#19BC31" : "#FF4343",
              fontSize: "12px",
              display: "inline-block",
              minWidth: "fit-content",
              padding: "6px 12px",
              textAlign: "center",
            }}
            className="rounded-pill text-white fw-semibold"
          >
            {statusText}
          </span>
        );
      },
      minWidth: "130px",
      center: true,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown(row)}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },

    // {
    //   name: "",
    //   selector: (row) => <div onClick={()=>router.push(`/sales/${type}/${row.id}`)}><BsThreeDots size={25}/></div>,
    //   width:'70px'
    // },
  ];
};

export const EminutesHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => <span className="text-muted">{row.serialNumber}</span>,
      width: "70px",
    },
    {
      name: "Minutes title",
      selector: (row) => <span style={{ width: "50px" }}>{row?.title}</span>,
      width: "300px",
    },
    {
      name: "Date",
      selector: (row) => (
        <div className="px-3 d-flex align-items-center">{row?.date}</div>
      ),
    },
    {
      name: "Audience",
      selector: (row) => (
        <span className="text-muted">
          {row?.audience ? convertToTitleCase(row.audience) : "—"}
        </span>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => (
        <span
          style={{ color: row?.status === "PUBLISHED" ? "#19BC31" : "#FF4343" }}
        >
          {row?.status}
        </span>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown(row)}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },
  ];
};

export const CommunicationGroupListHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => (
        <span className="fw-bold text-black">{row.serialNumber}</span>
      ),
      width: "70px",
    },
    {
      name: "Group name",
      cell: (row) => <span>{row?.name}</span>,
    },
    {
      name: "No. of members",
      selector: (row) => row?.totalMembers,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
    },
  ];
};

export const CommunicationGroupMembersHeader = (TableDropDown) => {
  return [
    {
      name: "S/N",
      selector: (row) => (
        <span className="fw-bold" style={{ color: "#45464e", fontSize: "14px" }}>
          {row.serialNumber}
        </span>
      ),
      width: "80px",
      minWidth: "80px",
    },
    {
      name: "Name",
      cell: (row) => {
        // Handle both members and staff
        const isStaff = row?.user_type === "staff" || (row?.staff_id && !row?.member_id);
        const user = isStaff ? row?.staff : row?.member;
        
        return (
          <span style={{ color: "#45464e", fontSize: "14px", fontWeight: 400 }}>
            {user?.first_name || ""} {user?.other_name || ""}{" "}
            {user?.last_name || ""}
          </span>
        );
      },
      minWidth: "200px",
    },
    {
      name: "User Type",
      cell: (row) => {
        // Determine user type
        const isStaff = row?.user_type === "staff" || (row?.staff_id && !row?.member_id);
        const userType = isStaff ? "staff" : "member";
        const displayText = convertToTitleCase(userType);
        
        // Color coding: Staff = Teal (var(--color-secondary)), Member = Primary (var(--color-primary))
        const badgeColor = isStaff ? "var(--color-secondary)" : "var(--color-primary)";
        
        return (
          <span
            style={{
              backgroundColor: badgeColor,
              color: "#ffffff",
              padding: "4px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              display: "inline-block",
            }}
          >
            {displayText}
          </span>
        );
      },
      minWidth: "120px",
      width: "120px",
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="text-center">
          <DropDownComp
            dropLabelClassName={"bg-white border-0 px-3 py-1 rounded-4 text-2"}
            arrayComp={TableDropDown}
            ItemClassName="pe-5 text-2"
            input="name"
            row={row}
            DropDownText={
              <span>
                <BsThreeDotsVertical size={20} className="table-action-icon" />
              </span>
            }
          />
        </div>
      ),
      width: "100px",
      minWidth: "100px",
    },
  ];
};
export const CommunicationMessagesHeader = (TableDropDown, onRowClick) => {
  const getChannelLabel = (sendingMode) => {
    if (!sendingMode) return "-";
    const m = (sendingMode || "").toLowerCase();
    if (m.includes("both")) return "SMS & Email";
    if (m.includes("sms")) return "SMS";
    if (m.includes("email")) return "Email";
    return convertToTitleCase(sendingMode);
  };
  const getAudienceLabel = (row) => {
    if (row?.audience_type) return convertToTitleCase(row.audience_type);
    if (row?.receipt_type_id === 2) return "Individual";
    if (row?.receipt_type_id === 1 && row?.group?.name) return row.group.name;
    return "Group";
  };
  return [
    {
      name: "S/N",
      selector: (row) => (
        <span className="fw-bold text-black">{row.serialNumber}</span>
      ),
      width: "70px",
    },
    {
      name: "Date",
      cell: (row) => (
        <span>
          {row?.created_at
            ? moment(row.created_at).format("DD-MMM-YYYY")
            : "-"}
        </span>
      ),
      width: "110px",
    },
    {
      name: "Last Updated",
      cell: (row) => {
        if (!row?.updated_at) return <span className="text-muted">-</span>;
        const updatedAt = moment(row.updated_at);
        const isRecent = moment().diff(updatedAt, "days") < 7; // Show relative time for recent updates
        
        return (
          <span
            title={updatedAt.format("DD-MMM-YYYY HH:mm")}
            className={isRecent ? "" : "text-muted"}
            style={{ fontSize: "13px" }}
          >
            {updatedAt.fromNow()}
          </span>
        );
      },
      width: "130px",
    },
    {
      name: "Title",
      cell: (row) => <span>{row?.header || "-"}</span>,
      minWidth: "140px",
    },
    {
      name: "Message type",
      cell: (row) => (
        <span>{convertToTitleCase(row?.message_type || "-")}</span>
      ),
      width: "120px",
    },
    {
      name: "Audience",
      cell: (row) => <span>{getAudienceLabel(row)}</span>,
      width: "120px",
    },
    {
      name: "Channel",
      cell: (row) => (
        <span>{getChannelLabel(row?.sending_mode)}</span>
      ),
      width: "110px",
    },
    {
      name: "Sent by",
      cell: (row) => (
        <span>
          {row?.created_by
            ? row?.created_by_staff?.first_name
              ? `${row.created_by_staff.first_name} ${row.created_by_staff.last_name}`
              : `Staff #${row.created_by}`
            : "-"}
        </span>
      ),
      width: "120px",
    },
    {
      name: "Status",
      cell: (row) => {
        const status = row?.status || "";
        const color = getStatusBadgeColor(status);
        return (
          <span
            className="badge rounded-pill"
            style={{
              backgroundColor: color,
              color: "#fff",
              padding: "4px 10px",
              fontSize: "12px",
            }}
          >
            {convertToTitleCase(status || "Unknown")}
          </span>
        );
      },
      width: "100px",
    },
    ...(onRowClick
      ? [
          {
            name: " ",
            cell: (row) => {
              const isDraft = (row?.status || "").toUpperCase() === "DRAFTED";
              return (
                <div className="d-flex align-items-center gap-2">
                  {isDraft && row?.onEdit ? (
                    <span
                      role="button"
                      className="text-primary1"
                      style={{ cursor: "pointer", fontSize: "14px", fontWeight: "500" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        row.onEdit(row);
                      }}
                    >
                      Edit
                    </span>
                  ) : (
                    <span
                      role="button"
                      className="text-primary"
                      style={{ cursor: "pointer", fontSize: "14px" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onRowClick(row);
                      }}
                    >
                      View
                    </span>
                  )}
                </div>
              );
            },
            width: "70px",
          },
        ]
      : []),
  ];
};

// Member Communication Messages Header (read-only view for members)
export const MemberCommunicationMessagesHeader = (onRowClick) => {
  const getChannelLabel = (sendingMode) => {
    if (!sendingMode) return "-";
    const m = (sendingMode || "").toLowerCase();
    if (m.includes("both")) return "SMS & Email";
    if (m.includes("sms")) return "SMS";
    if (m.includes("email")) return "Email";
    return convertToTitleCase(sendingMode);
  };
  const getAudienceLabel = (row) => {
    if (row?.audience_type) return convertToTitleCase(row.audience_type);
    if (row?.receipt_type_id === 2) return "Individual";
    if (row?.receipt_type_id === 1 && row?.group?.name) return row.group.name;
    return "Group";
  };
  const getReadStatusBadgeColor = (isRead) => {
    return isRead ? "#19BC31" : "#FF9500"; // Green for read, Orange for unread
  };
  const getDeliveryStatusColor = (status) => {
    return getStatusBadgeColor(status);
  };
  return [
    {
      name: "S/N",
      selector: (row) => (
        <span className="fw-bold text-black">{row.serialNumber}</span>
      ),
      width: "70px",
    },
    {
      name: "Date",
      cell: (row) => (
        <span>
          {row?.created_at
            ? moment(row.created_at).format("DD-MMM-YYYY")
            : "-"}
        </span>
      ),
      width: "110px",
    },
    {
      name: "Title",
      cell: (row) => <span>{row?.header || "-"}</span>,
      minWidth: "140px",
    },
    {
      name: "Message type",
      cell: (row) => (
        <span>{convertToTitleCase(row?.message_type || "-")}</span>
      ),
      width: "120px",
    },
    {
      name: "Audience",
      cell: (row) => <span>{getAudienceLabel(row)}</span>,
      width: "120px",
    },
    {
      name: "Channel",
      cell: (row) => (
        <span>{getChannelLabel(row?.sending_mode)}</span>
      ),
      width: "110px",
    },
    {
      name: "Sent by",
      cell: (row) => (
        <span>
          {row?.created_by
            ? row?.created_by_staff?.first_name
              ? `${row.created_by_staff.first_name} ${row.created_by_staff.last_name}`
              : `Staff #${row.created_by}`
            : "-"}
        </span>
      ),
      width: "120px",
    },
    {
      name: "Delivery Status",
      cell: (row) => {
        // Show member-specific delivery status
        const deliveryStatus = row?.member_delivery_status || row?.delivery_status || row?.status || "";
        const color = getDeliveryStatusColor(deliveryStatus);
        return (
          <span
            className="badge rounded-pill"
            style={{
              backgroundColor: color,
              color: "#fff",
              padding: "4px 10px",
              fontSize: "12px",
            }}
          >
            {convertToTitleCase(deliveryStatus || "Unknown")}
          </span>
        );
      },
      width: "120px",
    },
    {
      name: "Read Status",
      cell: (row) => {
        const isRead = row?.is_read === true || row?.is_read === 1 || row?.read_at !== null;
        const color = getReadStatusBadgeColor(isRead);
        return (
          <span
            className="badge rounded-pill"
            style={{
              backgroundColor: color,
              color: "#fff",
              padding: "4px 10px",
              fontSize: "12px",
            }}
          >
            {isRead ? "Read" : "Unread"}
          </span>
        );
      },
      width: "100px",
    },
    ...(onRowClick
      ? [
          {
            name: " ",
            cell: (row) => (
              <span
                role="button"
                className="text-primary"
                style={{ cursor: "pointer", fontSize: "14px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  onRowClick(row);
                }}
              >
                View
              </span>
            ),
            width: "70px",
          },
        ]
      : []),
  ];
};

export const ContributionHistoryV2Header = () => {
  return [
    {
      name: "S/N",
      selector: (row, index) => <span className="text-muted">{index + 1}</span>,
      width: "70px",
    },
    {
      name: "Member",
      selector: (row) => (
        <div>
          <div className="fw-bold">
            {row?.member?.first_name && row?.member?.last_name
              ? `${row?.member?.first_name} ${row?.member?.last_name}`
              : row?.member?.name || "-"}
          </div>
          <small className="text-muted">
            {row?.member?.member_no ? `#${row?.member?.member_no}` : "-"}
          </small>
        </div>
      ),
      minWidth: "180px",
    },
    {
      name: "Contribution Type",
      selector: (row) => (
        <div>
          <div className="fw-bold">{row?.category?.name || "-"}</div>
        </div>
      ),
      minWidth: "180px",
    },
    {
      name: "Amount",
      selector: (row) => (
        <span className="fw-bold">{formatMoney(row?.amount || "0", true)}</span>
      ),
      minWidth: "120px",
    },
    {
      name: "Payment Date",
      selector: (row) => (
        <div>
          <div>
            {row?.paymentDate
              ? moment(row?.paymentDate).format("DD-MMM-YYYY")
              : row?.payment_date
              ? moment(row?.payment_date).format("DD-MMM-YYYY")
              : "-"}
          </div>
          <small className="text-muted">
            {row?.created_at ? moment(row?.created_at).format("HH:mm") : ""}
          </small>
        </div>
      ),
      minWidth: "140px",
    },
    {
      name: "Payment Method",
      selector: (row) => <span>{row?.payment_type?.name || "-"}</span>,
      minWidth: "140px",
    },
    {
      name: "Transaction Code",
      selector: (row) => (
        <div>
          <div className="fw-bold">
            {row?.transactionCode || row?.transaction_code || "-"}
          </div>
          {row?.track_no && (
            <small className="text-muted">Track: {row?.track_no}</small>
          )}
        </div>
      ),
      minWidth: "160px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = row?.status || "";
        const statusColors = {
          SUCCESSFUL: "#19BC31",
          PENDING: "#FFA500",
          FAILED: "#FF4343",
        };
        const statusColor = statusColors[status?.toUpperCase()] || "#A1A0A0";
        return (
          <span
            className="rounded-pill px-3 py-1 text-white"
            style={{
              backgroundColor: statusColor,
              fontSize: "12px",
              whiteSpace: "nowrap",
            }}
          >
            {convertToTitleCase(status)}
          </span>
        );
      },
      minWidth: "120px",
    },
    {
      name: "Action",
      selector: (row) => {
        return (
          <button
            className="btn btn-sm text-primary1"
            onClick={() => {
              if (row?.onViewClick) {
                row.onViewClick(row);
              }
            }}
            style={{
              whiteSpace: "nowrap",
              minWidth: "fit-content",
              borderColor: "var(--color-primary)",
              backgroundColor: "transparent",
            }}
          >
            View Details
          </button>
        );
      },
      minWidth: "130px",
    },
  ];
};

export const AdminMemberExitRequestsHeader = (actionHandlers) => {
  const getStatusColor = (status) => {
    const statusUpper = (status || "").toUpperCase();
    if (statusUpper === "PAID" || statusUpper === "APPROVED") return "#19BC31";
    if (statusUpper === "PENDING") return "#FFA500";
    if (statusUpper === "DECLINED" || statusUpper === "CANCELED") return "#FF4343";
    return "#A1A0A0";
  };

  return [
    {
      name: "S/N",
      selector: (row, index) => (
        <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
          {index + 1}
        </span>
      ),
      width: "70px",
    },
    {
      name: "Member",
      selector: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-bold text-black1" style={{ fontSize: "14px" }}>
            {row?.member?.first_name && row?.member?.last_name
              ? `${row.member.first_name} ${row.member.last_name}`
              : "-"}
          </span>
          <span className="text-muted small" style={{ fontSize: "12px" }}>
            {row?.member?.member_no ? `#${row.member.member_no}` : ""}
          </span>
        </div>
      ),
      minWidth: "180px",
    },
    {
      name: "Request Date",
      selector: (row) => (
        <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
          {moment(row?.created_at).format("DD-MMM-YYYY")}
        </span>
      ),
      minWidth: "130px",
    },
    {
      name: "Payout",
      selector: (row) => (
        <span className="fw-bold text-black1" style={{ fontSize: "14px" }}>
          {formatMoney(Number(row?.payout_amount || 0).toFixed(2), true, "₦")}
        </span>
      ),
      minWidth: "140px",
    },
    {
      name: "Bank Account",
      selector: (row) => (
        <div className="d-flex flex-column">
          <span className="fw-2 text-black1" style={{ fontSize: "14px" }}>
            {row?.bank_account?.bank_name || "N/A"}
          </span>
          <span className="text-muted small" style={{ fontSize: "12px" }}>
            {row?.bank_account?.account_number || ""}
          </span>
        </div>
      ),
      minWidth: "160px",
    },
    {
      name: "Status",
      selector: (row) => {
        const status = row?.status || "PENDING";
        return (
          <span
            className="px-3 py-1 rounded-pill text-white fw-semibold"
            style={{
              backgroundColor: getStatusColor(status),
              fontSize: "12px",
              whiteSpace: "nowrap",
              display: "inline-block",
              minWidth: "100px",
            }}
          >
            {convertToTitleCase(status)}
          </span>
        );
      },
      minWidth: "120px",
    },
    {
      name: "Actions",
      cell: (row) => {
        const status = (row?.status || "PENDING").toUpperCase();
        const handlers = actionHandlers || {};
        return (
          <div className="d-flex align-items-center gap-2" style={{ whiteSpace: "nowrap" }}>
            {handlers.onViewDetails && (
              <ButtonComp
                btnText="View"
                btnClassName="btn py-1 px-2"
                BorderColor="var(--color-primary)"
                onClick={() => handlers.onViewDetails(row.id)}
                ButtonInlineStyle={{ whiteSpace: "nowrap", minWidth: "fit-content" }}
              />
            )}
            {status === "PENDING" && handlers.onApprove && (
              <ButtonComp
                btnText="Approve"
                btnClassName="btn py-1 px-2 text-white border-0"
                ButtonInlineStyle={{
                  backgroundColor: "#19BC31",
                  whiteSpace: "nowrap",
                  minWidth: "fit-content",
                }}
                onClick={() => handlers.onApprove(row.id)}
              />
            )}
            {status === "PENDING" && handlers.onDecline && (
              <ButtonComp
                btnText="Decline"
                btnClassName="btn py-1 px-2 text-white border-0"
                ButtonInlineStyle={{
                  backgroundColor: "#FF4343",
                  whiteSpace: "nowrap",
                  minWidth: "fit-content",
                }}
                onClick={() => handlers.onDecline(row.id)}
              />
            )}
            {status === "APPROVED" && handlers.onMarkPaid && (
              <ButtonComp
                btnText="Mark Paid"
                btnClassName="btn py-1 px-2 text-white border-0"
                ButtonInlineStyle={{
                  backgroundColor: "#31778C",
                  whiteSpace: "nowrap",
                  minWidth: "fit-content",
                }}
                onClick={() => handlers.onMarkPaid(row.id)}
              />
            )}
          </div>
        );
      },
      minWidth: "280px",
    },
  ];
};

export const ExitedMembersHeader = () => [
  {
    name: "S/N",
    selector: (row, index) => (
      <span className="text-muted fw-2" style={{ fontSize: "14px" }}>
        {index + 1}
      </span>
    ),
    width: "70px",
  },
  {
    name: "Membership Number",
    selector: (row) => row?.member_no || "-",
    minWidth: "140px",
  },
  {
    name: "Name",
    selector: (row) =>
      `${row?.first_name || ""} ${row?.last_name || ""}`.trim() || "-",
    minWidth: "180px",
  },
  {
    name: "Email",
    selector: (row) => row?.email || "-",
    minWidth: "180px",
  },
  {
    name: "Phone",
    selector: (row) => row?.phone || "-",
    minWidth: "130px",
  },
  {
    name: "Exited At",
    selector: (row) =>
      row?.exited_at ? moment(row.exited_at).format("DD-MMM-YYYY") : "-",
    minWidth: "130px",
  },
  {
    name: "Status",
    selector: () => (
      <span
        className="px-3 py-1 rounded-pill text-white fw-semibold"
        style={{ backgroundColor: "#A1A0A0", fontSize: "12px" }}
      >
        Exited
      </span>
    ),
    minWidth: "110px",
  },
];

